import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2, AfterViewChecked } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import { BufferChangeHistory } from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';
import { OnDropdownFilteredEventArgs } from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import { EventArgs } from 'app/slick-grid/models/event-args';
import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ExportExcelColumn} from "../../../shared/models/export-excel-column";
import {ModuleTableName} from "../../../shared/models/module-table-name";

@Component({
    selector: 'buffer-change-history',
    templateUrl: './buffer-change-history.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './buffer-change-history.component.css']
})
export class BufferChangeHistoryComponent extends TabComponentBase<BufferChangeHistory, { columns: ExportExcelColumn[], mainRows: any[] }> implements AfterViewChecked {
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ){
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);
        this.showAllData = new EventEmitter<void>();
        this.dataView = new Slick.Data.DataView<BufferChangeHistory>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());
        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };
        this.generateColumns = true;
        this.gridPropsName = new ModuleTableName('Stocks', 'BufferChangeHistory');
        this.translateService.get('BufferChangeHistory').subscribe(t => this.mainRowsSheetName = t);

    }

    @Input()
    public isActive: boolean;

    @Input()
    private allShown: boolean;

    private data: BufferChangeHistory[];

    @Input()
    private set changes(changes: BufferChangeHistory[]) {
        this.data = changes;

        this.dropdownFilters = [];

        this.dataView.beginUpdate();
        this.dataView.setItems(changes);
        //this.dataView.setFilter(o => this.filterChangeHistory(o));
        this.dataView.endUpdate();
    }

    @Input()
    protected sku: string;

    @Input()
    protected warehouseCode: string;

    @Input()
    public canSend: boolean;

    @Output()
    private readonly showAllData: EventEmitter<void>;

    private dropdownFilters: OnDropdownFilteredEventArgs<BufferChangeHistory>[];

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# show all data foe tab (not use)
    /*private onShowAllClick = (): void => {
        if (this.allShown)
            return;

        this.showAllData.emit();
    }*/

    //# download excel
    public onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadReport(
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            []
        )
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    public onSendClick = (): void => {
        this.sendToEmail(data => this.excelService.sendReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            [],
            this.mainRowsSheetName
        ));
    }

    public onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<BufferChangeHistory>>): void => {
        //this.gridRef.filterHelper.onGridFiltered(args, type);
        //this.dataView.refresh();
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-change-history.component/buffer-change-history.component.ts